;(function() {
  'use strict'

  Controller.$inject = ["$http", "$state", "$q", "glAnalytics", "glAuthService", "configService", "userService", "creditPromotionService", "countryService", "industryService"];
  angular.module('app.signup').controller('Signup', Controller)

  /* @ngInject */
  function Controller(
    $http,
    $state,
    $q,
    glAnalytics,
    glAuthService,
    configService,
    userService,
    creditPromotionService,
    countryService,
    industryService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onSignupCompleted = onSignupCompleted
    ctrl.loginDialog = loginDialog

    function onInit() {
      ctrl.isLoading = true
      parseParams()
      attemptLogin()
        .then(getLocation)
        .then(loadPromo)
        .finally(function() {
          makeOptions()
          ctrl.isLoading = false
        })
    }

    function parseParams() {
      ctrl.contentGroupIds = $state.params.contentGroupIds
        ? $state.params.contentGroupIds.split(',')
        : []
      ctrl.country = $state.params.country
        ? countryService.getById($state.params.country)
        : undefined
      ctrl.industry = $state.params.industry
        ? industryService.getById($state.params.industry)
        : undefined
      ctrl.bannerImageUrl = $state.params.bannerImageUrl
      ctrl.hideOverview = $state.params.hideOverview === 'true'
      ctrl.hideCompany = true // Default to hidden
      ctrl.referrerCode = $state.params.referrerCode
      ctrl.isSteadfast = $state.params.promo === 'steadfast'
      ctrl.promo =
        $state.params.promo === 'steadfast' ? null : $state.params.promo
      ctrl.token = $state.params.token
      ctrl.preferredExternalPanelId = $state.params.ppp
      ctrl.allowAddIntegratedPanel = $state.params.ip !== 'false'
      ctrl.allowAddExternalPanel = $state.params.ep !== 'false'
      ctrl.enableExternalPanelFlag = $state.params.ep !== 'false'
      ctrl.utm_source = $state.params.utm_source
      ctrl.utm_medium = $state.params.utm_medium
      ctrl.utm_campaign = $state.params.utm_campaign
      ctrl.utm_term = $state.params.utm_term
      ctrl.utm_content = $state.params.utm_content

      // params from consume-invite redirect
      ctrl.organisationName = $state.params.organisationName
      var redirectedFrom = $state.transition.options().custom.redirectedFrom
      ctrl.isInvited = redirectedFrom === 'consume-invite'
    }

    function makeOptions() {
      // These fields are primarily for registrationContext but some fields are also
      // for the subscriber, so it is named "options" to differentiate.
      ctrl.options = {
        referrerCode: ctrl.referrerCode,
        utm_source: ctrl.utm_source,
        utm_medium: ctrl.utm_medium,
        utm_campaign: ctrl.utm_campaign,
        utm_term: ctrl.utm_term,
        utm_content: ctrl.utm_content,
        contentGroupIds: ctrl.contentGroupIds,
        isSteadfast: ctrl.isSteadfast,
        promotion: ctrl.promotion,
        country: ctrl.country,
        industry: ctrl.industry,
        hideCompany: ctrl.hideCompany,
        preferredExternalPanelId: ctrl.preferredExternalPanelId,
        allowAddIntegratedPanel: ctrl.allowAddIntegratedPanel,
        allowAddExternalPanel: ctrl.allowAddExternalPanel,
        enableExternalPanelFlag: ctrl.enableExternalPanelFlag,
      }
    }

    function attemptLogin() {
      return $q(function(resolve, reject) {
        if (userService.hasCredentials()) {
          track('signup-auto-login')
          goToPortal()
          reject()
        } else {
          resolve()
        }
      })
    }

    function loadPromo() {
      if (!ctrl.token) {
        return $q.resolve()
      }
      return creditPromotionService
        .getByToken(ctrl.token)
        .then(function(promotion) {
          if (promotion.status === 'pending') {
            ctrl.promotion = promotion
            glAnalytics.track(
              'subscriber-promotion',
              'offered-at-signup',
              promotion.code
            )
          } else {
            ctrl.notPending = true
          }
        })
        .catch(function() {
          ctrl.promoNotFound = true
        })
    }

    function getLocation() {
      if (ctrl.country) return $q.resolve() // it was passed in via param
      return $http({
        method: 'GET',
        url: configService.getNodeUrl('/geolocation'),
      })
        .then(function(resp) {
          var countryCode = resp.data.country_code
          ctrl.country = countryService.getByCC(countryCode)
        })
        .catch(function() {
          ctrl.country = countryService.getByCC('AU')
          return $q.resolve()
        })
    }

    function onSignupCompleted() {
      if (!ctrl.token) {
        return goToPortal()
      }
      creditPromotionService
        .activate(ctrl.token)
        .then(function() {
          track('signup-completed')
          if (ctrl.promotion) {
            glAnalytics.track(
              'subscriber-promotion',
              'offer-accepted-with-signup',
              ctrl.promotion.subscriptionCode
            )
            glAnalytics.set('promo', ctrl.promotion.subscriptionCode)
          }
          goToPortal(true)
        })
        .catch(function() {
          ctrl.promoNotFound = true
        })
    }

    function goToPortal(promoActivated) {
      if (ctrl.isInvited) {
        return userService.redirectToRequestedUrl()
      }
      $state.go('dashboard', {
        didSignup: true,
        promoActivated: promoActivated,
      })
    }

    function loginDialog() {
      userService
        .loginDialog({
          allowedRoles: [
            glAuthService.Roles.SUBSCRIBER,
            glAuthService.Roles.SUBSCRIBER_SUPPORT,
          ],
        })
        .then(function() {
          track('signup-manual-login-success')
          goToPortal()
        })
        .catch(function(reason) {
          if (reason === 'passwordReset') {
            $state.go('passwordReset')
            return
          }
          track('signup-manual-login-error')
        })
    }

    function track(action) {
      glAnalytics.track('signup', action, ctrl.contentGroupIds.join(','))
    }
  }
})()
